import apiSlice from "./apiSlice";

const programDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProgramSummary: builder.query({
            query: () => ({
                url: `project/summary`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProgramSummary"],
        }),
    }),
});

export const {
    useGetProgramSummaryQuery,
} = programDashboardApiSlice;
